import { Power } from 'lucide-react';

import type { UserRow } from '../userViewModel';

export default function DeactivateHeader({
  user,
  step,
}: {
  user: UserRow;
  step: 'review' | 'confirm';
}) {
  return (
    <div className="px-[22px] pt-5 pb-3.5 flex items-center gap-3">
      <div className="w-10 h-10 rounded-lg bg-clay-50 dark:bg-clay-900/20 text-clay-700 dark:text-clay-300 flex items-center justify-center flex-none">
        <Power size={20} />
      </div>
      <div className="flex-1">
        <h2
          id="deactivate-title"
          className="m-0 text-xl font-bold text-bark-900 dark:text-[#e8ece9] leading-none"
        >
          {step === 'review' ? 'Deactivate user?' : 'Confirm deactivation'}
        </h2>
        <div className="text-[12.5px] text-stone-600 dark:text-stone-400 mt-1.5 leading-snug">
          <strong className="text-bark-900 dark:text-[#e8ece9]">{user.name}</strong>{' '}
          {step === 'review'
            ? 'will be unable to log in. Their records stay in audit logs and historical reports.'
            : 'will lose login access immediately. You can reactivate them later if needed.'}
        </div>
      </div>
    </div>
  );
}
